<template>
  <div class="cfbody" >
    <el-divider content-position="left">云文档列表</el-divider>
    <div style="display: flex">
      <el-select
        v-model="searchArr.title"
        filterable
        remote
        reserve-keyword
        placeholder="请输入标题名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCfTitle"
        :loading="searchLoading"
        @change="handleSearchCfTitle"
      >
        <el-option
          v-for="searchCompany in searchTitles"
          :key="searchCompany.id"
          :label="searchCompany.title"
          :value="searchCompany.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
        <el-button type="primary" size="mini" @click="categoryIn"
          >录入</el-button
        >
      </div>
    </div>
    <el-drawer
      title="录入"
      :visible.sync="categoryIndrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryForm"
          :rules="rules"
          ref="categoryForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="categoryId">
            <el-select
              size="mini"
              v-model="categoryForm.categoryId"
              clearable
              placeholder="请选择分类"
              style="width: 100%"
              @click.native="getCate"
              filterable
            >
              <el-option
                v-for="item in cateOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="云文档标题" prop="title">
            <el-input v-model="categoryForm.title" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="云文档链接" prop="body">
            <el-input v-model="categoryForm.body" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="云文档概述" prop="desc">
            <el-input
              size="mini"
              type="textarea"
              v-model="categoryForm.desc"
            ></el-input>
          </el-form-item>
          <el-form-item label="可查看角色" prop="role">
            <el-select
              size="mini"
              v-model="categoryForm.role"
              clearable
              placeholder="请选择角色"
              style="width: 100%"
              @click.native="getRole"
              multiple
              filterable
            >
              <el-option
                v-for="item in roleOptions"
                :key="item.id"
                :label="item.role_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可编辑角色" prop="edit_role">
            <el-select
              size="mini"
              v-model="categoryForm.edit_role"
              clearable
              placeholder="请选择角色"
              style="width: 100%"
              @click.native="getEditRole"
              multiple
              filterable
            >
              <el-option
                v-for="item in editRoleOptions"
                :key="item.id"
                :label="item.role_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="ifdisplay"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="submitForm('categoryForm')"
              >添加</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="修改"
      :visible.sync="categoryEditDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <el-form
          :model="categoryEditForm"
          :rules="rules"
          ref="categoryEditForm"
          label-width="100px"
        >
          <el-form-item label="分类名称" prop="categoryId">
            <!-- <el-select
              v-model="categoryEditForm.categoryId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入搜索分类名称"
              size="mini"
              clearable
              :remote-method="searchRemoteCfbodyEdit"
              :loading="searchLoading"
              style="width: 100%"
            >
              <el-option
                v-for="searchCompany in searchEditBodies"
                :key="searchCompany.id"
                :label="searchCompany.category_name"
                :value="searchCompany.id"
              >
              </el-option>
            </el-select> -->
            <el-select
              size="mini"
              v-model="categoryEditForm.categoryId"
              clearable
              placeholder="请选择分类"
              style="width: 100%"
              @click.native="getCateEdit"
              filterable
            >
              <el-option
                v-for="item in cateEditOptions"
                :key="item.id"
                :label="item.category_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="云文档标题" prop="title">
            <el-input v-model="categoryEditForm.title" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="云文档链接" prop="body">
            <el-input v-model="categoryEditForm.body" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="云文档概述" prop="desc">
            <el-input
              size="mini"
              type="textarea"
              v-model="categoryEditForm.desc"
            ></el-input>
          </el-form-item>
          <el-form-item label="可查看角色" prop="role">
            <el-select
              size="mini"
              v-model="categoryEditForm.role"
              clearable
              placeholder="请选择角色"
              style="width: 100%"
              filterable
              multiple
            >
              <el-option
                v-for="item in roleEditOptions"
                :key="item.id"
                :label="item.role_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可编辑角色" prop="edit_role">
            <el-select
              size="mini"
              v-model="categoryEditForm.edit_role"
              clearable
              placeholder="请选择角色"
              style="width: 100%"
              @click.native="getEditAbleRole"
              multiple
              filterable
            >
              <el-option
                v-for="item in editAbleRoleOptions"
                :key="item.id"
                :label="item.role_name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否显示" prop="display">
            是
            <el-switch
              v-model="editIfDisplay"
              active-color="#ff4949"
              inactive-color="#13ce66"
            >
            </el-switch>
            否
          </el-form-item>
          <div style="text-align: right">
            <el-button
              type="primary"
              size="mini"
              @click="editSubmitForm('categoryEditForm')"
              >修改</el-button
            >
          </div>
        </el-form>
      </div>
    </el-drawer>
    <el-drawer
      title="阅读记录"
      :visible.sync="categoryReadDrawer"
      :direction="direction"
      :before-close="handleClose"
      size="40%"
    >
      <div style="padding: 0.2em 1.4em; margin-top: -17px">
        <!-- <el-timeline style="height:26rem;overflow:auto;"> -->
        <el-timeline ref="box" style="height: 13rem; overflow: auto">
          <el-timeline-item
            v-for="r in fileReadRecOptions"
            :timestamp="r.created_at"
            placement="top"
            :key="r.id"
          >
            <el-card>
              <!-- <h4>更新 Github 模板</h4> -->
              <p>{{ r.reader }}, 在{{ r.created_at }}, 阅读了{{ r.title }}。</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>
    <el-table
    height="calc(100vh - 266px)"
      :data="categoryData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <!-- <el-table-column prop="id" label="ID"> </el-table-column> -->
      <el-table-column prop="title" label="标题" fixed>
        <template slot-scope="scope">
          <el-link
            type="primary"
            style="font-size: 0.28rem"
            @click="readRecord(scope.row)"
            >{{ scope.row.title }}</el-link
          >
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="录入时间" width="140">
        <template slot-scope="scope">
          <date-formatter :date-value="scope.row.created_at"></date-formatter>
        </template>
      </el-table-column>
      <el-table-column prop="ope_name" label="录入人"> </el-table-column>
      <el-table-column prop="desc" label="概述"> </el-table-column>
      <el-table-column prop="role_name" label="角色"> </el-table-column>
      <el-table-column prop="display" label="是否显示" width="100">
        <template slot-scope="scope">
          <div v-if="scope.row.display === 1">是</div>
          <div v-if="scope.row.display === 0">否</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" content="修改" placement="top">
            <el-button
              @click.native.prevent="editRow(scope.$index, categoryData)"
              type="primary"
              size="mini"
              icon="el-icon-edit"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <el-button
              @click.native.prevent="deleteRow(scope.$index, categoryData)"
              type="danger"
              size="mini"
              icon="el-icon-delete"
              circle
            >
            </el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="阅读记录"
            placement="top"
          >
            <el-button
              @click.native.prevent="readRow(scope.$index, categoryData)"
              type="success"
              size="mini"
              icon="el-icon-notebook-2"
              circle
            >
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>


    <div class="page-footer">
      <el-pagination
      class="pagination-style"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 30, 50, 100, 500]"
        :page-size="categoryPerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import DateFormatter from 'common/DateFormatter'
export default {
  name: 'Cfbody',
  components: {DateFormatter},
  data () {
    var categoryId = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入分类名称！'))
      }
      callback()
    }
    var checktitle = (rule, value, callback) => {
      if (value.length > 100) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入标题名称！'))
      }
      callback()
    }
    var checkbody = (rule, value, callback) => {
      if (value.length > 500) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请输入云文档链接！'))
      }
      callback()
    }
    var checkrole = (rule, value, callback) => {
      if (value.length > 50) {
        return callback(new Error('输入过长！'))
      }
      if (value.length === 0) {
        return callback(new Error('请选择角色！'))
      }
      callback()
    }
    var checkdesc = (rule, value, callback) => {
      if (value.length > 200) {
        return callback(new Error('输入内容限定200字！'))
      }
      // if (value.length === 0) {
      //   return callback(new Error('请选择角色！'))
      // }
      callback()
    }
    return {

      searchArr: {
        title: ''
      },
      npage: 1,
      categoryPerPage: 30,
      total: null,
      categoryData: [],
      searchTitles: [],
      searchBodies: [],
      searchEditBodies: [],
      roleOptions: [],
      cateOptions: [],
      cateEditOptions: [],
      roleEditOptions: [],
      dateCountData: [],
      fileReadRecOptions: [],
      editRoleOptions: [],
      searcher: null,
      categoryEditDrawer: false,
      categoryReadDrawer: false,
      searchLoading: false,
      searchCategories: [],
      editAbleRoleOptions: [],
      categoryIndrawer: false,
      editIfDisplay: false,
      direction: 'rtl',
      category: '',
      ideCateId: null,
      ifdisplay: false,
      lazyPage: 1,
      totalPage: 0,
      lazyIndex: '',
      lazyData: '',
      categoryForm: {
        categoryId: '',
        category_name: '',
        title: '',
        body: '',
        display: '',
        desc: '',
        role: '',
        edit_role: ''
      },
      categoryEditForm: {
        categoryId: '',
        category_name: '',
        title: '',
        body: '',
        display: '',
        desc: '',
        role: '',
        edit_role: ''
      },
      editCategoryForm: {
        categoryId: '',
        category_name: ''
      },
      rules: {
        categoryId: [
          {
            validator: categoryId,
            trigger: 'blur'
          }
        ],
        title: [
          {
            validator: checktitle,
            trigger: 'blur'
          }
        ],
        body: [
          {
            validator: checkbody,
            trigger: 'blur'
          }
        ],
        role: [
          {
            validator: checkrole,
            trigger: 'blur'
          }
        ],
        desc: [
          {
            validator: checkdesc,
            trigger: 'blur'
          }
        ]
      }
    }
  },
  mounted () {
    this.loadTable()
    this.loadCategory()
    this.loadRole()
    window.addEventListener('scroll', this.lazyLoading, true) // 监听滚动事件，然后用handleScroll这个方法进行相应的处理
    // this.$refs.box.addEventListener('scroll', this.lazyLoading) // 滚动到底部，再加载的处理事件
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  // watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    loadRole () {
      this.$axios
        .get('api/cloudbody/role')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.roleEditOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    loadCategory () {
      this.$axios
        .get('api/cloudbody/getcate')
        .then(({ data }) => {
          if (data.code === 1) {
            this.cateEditOptions = data.data
          }
        })
        .catch()
    },
    loadTable () {
      this.$axios
        .get('api/cloudbody/index', {
          params: {
            page: this.npage,
            perpage: this.categoryPerPage,
            searchItem: this.searcher
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryData = data.data.data
            this.total = data.data.total
          }
        })
        .catch()
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.categoryPerPage = val
      this.loadTable()
    },
    editRow (index, data) {
      this.getEditAbleRole()
      this.$axios
        .get('api/cloudbody/show', {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.categoryEditForm.categoryId = data.data.cate.cate_id
            this.ideCateId = data.data.cate.cate_id
            this.categoryEditForm.title = data.data.title
            this.categoryEditForm.body = data.data.body
            this.categoryEditForm.desc = data.data.desc
            if (data.data.role_id) {
              var roleArr = data.data.role_id.split(',')
              var newArr = roleArr.map((item, index) => {
                return Number(item)
              })
              this.categoryEditForm.role = newArr
            }
            if (data.data.edit_role_id) {
              var ableRoleArr = data.data.edit_role_id.split(',')
              var newAbleArr = ableRoleArr.map((item, index) => {
                return Number(item)
              })
              this.categoryEditForm.edit_role = newAbleArr
            }
            this.editIfDisplay = data.data.display === 1 ? null : true
            this.category = data.data.id
          }
        })
        .catch()
      this.categoryEditDrawer = true
    },
    readRow (index, data) {
      this.lazyPage = 1
      this.lazyIndex = index
      this.lazyData = data
      this.$axios
        .get('api/cloudbody/getrecord?page=' + this.lazyPage, {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            // this.fileReadRecOptions = data.data.data
            this.fileReadRecOptions = this.fileReadRecOptions.concat(
              data.data.data
            )
            this.lazyPage = data.data.current_page
            this.totalPage = data.data.last_page
          }
        })
        .catch()
      this.categoryReadDrawer = true
      // setTimeout(() => {
      //   this.$refs.box.addEventListener('scroll', this.lazyLoading) // 滚动到底部，再加载的处理事件
      // })
    },
    deleteRow (index, data) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$axios
            .delete('api/cloudbody/del', {
              params: {
                id: data[index].id
              }
            })
            .then(({ data }) => {
              if (data.code === 1) {
                this.loadTable()
                this.$message.success(data.msg)
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    searchRemoteCfcategory (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchCategories = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/cloudbody/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchCategories = data.data
          }
        })
        .catch()
    },
    searchRemoteCfTitle (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemTitle(query)
        }, 200)
      } else {
        this.searchtitles = []
      }
    },
    searchItemTitle (query) {
      this.$axios
        .get('api/cloudbody/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchTitles = data.data
          }
        })
        .catch()
    },
    searchRemoteCfbody (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemBody(query)
        }, 200)
      } else {
        this.searchBodies = []
      }
    },
    searchItemBody (query) {
      this.$axios
        .get('api/cloudfile/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchBodies = data.data
          }
        })
        .catch()
    },
    searchRemoteCfbodyEdit (query) {
      if (query !== '') {
        this.ideCateId = null
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItemBodyEdit(query)
        }, 200)
      } else {
        this.searchEditBodies = []
      }
    },
    searchItemBodyEdit (query) {
      this.$axios
        .get('api/cloudfile/getitem', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchEditBodies = data.data
          }
        })
        .catch()
    },
    handleSearchCfcategory (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleSearchCfTitle (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    handleSearchCfBody (query) {
      this.searcher = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    categoryIn () {
      this.categoryIndrawer = true
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
          this.fileReadRecOptions = []
          this.lazyPage = 1
          this.totalPage = 0
          this.$refs['categoryEditForm'].resetFields()
          this.$refs['categoryForm'].resetFields()
        })
        .catch(_ => {})
    },
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .post('api/cloudbody/store', {
              cate_id: this.categoryForm.categoryId,
              title: this.categoryForm.title,
              body: this.categoryForm.body,
              display: this.ifdisplay ? 0 : 1,
              desc: this.categoryForm.desc,
              role: this.categoryForm.role,
              edit_role: this.categoryForm.edit_role
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryIndrawer = false
                this.loadTable()
                this.$refs['categoryForm'].resetFields()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    editSubmitForm (formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$axios
            .put('api/cloudbody/edit', {
              id: this.category,
              ideCateId: this.ideCateId,
              cateId: this.categoryEditForm.categoryId,
              title: this.categoryEditForm.title,
              body: this.categoryEditForm.body,
              display: this.editIfDisplay ? 0 : 1,
              desc: this.categoryEditForm.desc,
              role: this.categoryEditForm.role,
              edit_role: this.categoryEditForm.edit_role
            })
            .then(res => {
              const { data } = res
              if (data.code === 1) {
                this.$message.success(data.msg)
                this.categoryEditDrawer = false
                this.loadTable()
                this.editAbleRoleOptions = []
                this.$refs['categoryEditForm'].resetFields()
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    getRole () {
      this.$axios
        .get('api/cloudbody/role')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.roleOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getEditRole () {
      this.$axios
        .get('api/cloudbody/role')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.editRoleOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getEditAbleRole () {
      this.$axios
        .get('api/cloudbody/role')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.editAbleRoleOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getCate () {
      this.$axios
        .get('api/cloudbody/cate')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.cateOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    getCateEdit () {
      this.$axios
        .get('api/cloudbody/cate')
        .then(res => {
          const { data } = res
          if (data.code === 1) {
            this.cateEditOptions = data.data
          } else {
            this.$message.error(data.msg)
          }
        })
        .catch()
    },
    readRecord (row) {
      let newPage = this.$router.resolve({
        path: '/documentation',
        query: { url: row.body }
      })
      window.open(newPage.href, '_blank')

      this.$axios
        .post('api/cloudbody/readrecord', {
          id: row.id,
          title: row.title
        })
        .then(({ data }) => {
          if (data.code === 1) {
            // this.comNoticeData = data.data.data
            // this.total = data.data.total
          }
        })
        .catch()
    },
    lazyGetData (index, data) {
      this.$axios
        .get('api/cloudbody/getrecord?page=' + this.lazyPage, {
          params: {
            id: data[index].id
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            // this.fileReadRecOptions = data.data.data
            this.fileReadRecOptions = this.fileReadRecOptions.concat(
              data.data.data
            )
            this.lazyPage = data.data.current_page
            this.totalPage = data.data.last_page
          }
        })
        .catch()
    },
    // 滚动加载
    lazyLoading (e) {
      const scrollTop = e.target.scrollTop // 滚动条滚动时，距离顶部的距离
      const windowHeight = e.target.clientHeight // 可视区的高度
      const scrollHeight = e.target.scrollHeight // 滚动条的总高度
      // console.log('距离顶部的高度')
      // console.log(scrollTop)
      // console.log('可视区的高度')
      // console.log(windowHeight)
      // console.log('总高度：')
      // console.log(scrollHeight)
      // console.log('1+2:')
      // console.log(scrollTop + windowHeight)
      // 滚动条到底部
      // Math.ceil(scrollTop + windowHeight) >= scrollHeight
      if (Math.floor(scrollTop + windowHeight) >= scrollHeight) {
        this.lazyPage++
        // console.log(this.totalPage)
        if (this.lazyPage > this.totalPage) {
          return false
        }

        this.lazyGetData(this.lazyIndex, this.lazyData)
      }
    }
  }
}
</script>

<style  scoped>
.cfbody {
  /* margin-left: 1.25rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}


.page-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 80px;
  background: #fff;
  width: 100%;
  z-index: 2;
}

.pagination-style {
  padding-top: 25px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/cloud_file/CFbody.vue